import type { ConnectorRow } from '../../types/aai';

/*
 * Version control (GitHub, GitLab) is connected once for the whole company in
 * the Workspace, never through Composio. Every list of company connections
 * therefore shows these rows with the Workspace's real state.
 */
export const isVersionControl = (row: ConnectorRow): boolean => row.category === 'code' || !!row.workspace_git;

export const versionControlStatus = (row: ConnectorRow): string | null => {
  if (row.workspace_git?.connected) return 'connected';
  return null;
};
